import { eventBus } from "@/package/helpers/eventBus";
// todo взять типы из ds как появятся
type NotifyTypes = "info" | "warning" | "success" | "error";

export const notify = (
  type: NotifyTypes,
  title: string,
  text: string | Error | unknown
) => {
  let message: string;

  if (text instanceof Error) {
    message = text.message;
  } else if (typeof text === "string") {
    message = text;
  } else {
    message = "Произошла неизвестная ошибка";
  }

  eventBus.emit("global-snackbar", { type, title, text: message });
};
